export default {
    getNameById: (state, getters) => id => {
        return state.names[id];
    },
    getCodeById: state => id => {
        return state.codes[id];
    }
};
